import { useCallback, useEffect, useState } from "react";
import { http, formatApiError } from "../../lib/api";

const fmt = (iso) => new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });

export const ExportLog = ({ month }) => {
  const [kind, setKind] = useState("");
  const [allMonths, setAllMonths] = useState(false);
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const load = useCallback(() => {
    let live = true;
    setErr("");
    http.get("/payroll/export-log", { params: { ...(kind ? { kind } : {}), ...(!allMonths && month ? { month } : {}) } })
      .then((r) => live && setData(r.data)).catch((e) => { if (live) { setData(null); setErr(formatApiError(e)); } });
    return () => { live = false; };
  }, [kind, month, allMonths]);
  useEffect(() => load(), [load]);
  if (err) return <p className="text-sm text-rose-700 py-10 text-center" data-testid="export-log-error">Journal indisponible : {err} <button type="button" onClick={load} className="underline font-semibold" data-testid="export-log-retry">Réessayer</button></p>;
  if (!data) return <p className="text-sm text-slate-500 py-10 text-center" data-testid="export-log-loading">Chargement…</p>;
  return (
    <div data-testid="export-log">
      <div className="flex flex-wrap items-end gap-2 mb-3">
        <label><div className="text-[10px] font-bold uppercase tracking-widest text-slate-500 mb-1">Type d'export</div>
          <select data-testid="export-log-kind" value={kind} onChange={(e) => setKind(e.target.value)} className="border border-slate-300 rounded-md px-2 py-1.5 text-sm min-w-[260px]">
            <option value="">Tous les exports</option>{Object.entries(data.kinds).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </label>
        <label className="inline-flex items-center gap-1.5 text-xs text-slate-700 pb-2"><input type="checkbox" checked={allMonths} onChange={(e) => setAllMonths(e.target.checked)} data-testid="export-log-all-months" />Tous les mois</label>
        <p className="text-[11px] text-slate-500 ml-auto">Visible par les administrateurs uniquement · 500 derniers exports</p>
      </div>
      {!data.rows.length ? <p className="text-sm text-slate-500 py-10 text-center" data-testid="export-log-empty">Aucun export enregistré.</p> : (
        <div className="border border-slate-200 bg-white rounded-md overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-[10px] uppercase tracking-widest text-slate-500 text-left">
              <tr><th className="px-3 py-2">Date</th><th className="px-3 py-2">Utilisateur</th><th className="px-3 py-2">Export</th><th className="px-3 py-2">Détail</th><th className="px-3 py-2">Site</th><th className="px-3 py-2 text-right">Lignes</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {data.rows.map((r) => (
                <tr key={r.id} data-testid={`export-log-row-${r.id}`}>
                  <td className="px-3 py-2 whitespace-nowrap font-mono text-xs">{fmt(r.at)}</td>
                  <td className="px-3 py-2"><div className="font-semibold">{r.user_name}</div><div className="text-[11px] text-slate-500">{r.user_email}</div></td>
                  <td className="px-3 py-2">{r.kind_label}</td>
                  <td className="px-3 py-2 text-slate-600">{r.label}</td>
                  <td className="px-3 py-2">{r.site_name || "—"}</td>
                  <td className="px-3 py-2 text-right font-mono">{r.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
